import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const AdminAuth = () => {
  if (!localStorage.getItem("adminToken")) {
    return <Navigate to="/admin" />;
  }

  return <Outlet />;
};
